import Repository from '../Repository';

const url = '/admin/messages';

export default {
    sendMessage(payload) {
        return Repository.post(`${url}/send`, payload);
    },
}
